export const b2b = 'b2b';
export const b2c = 'b2c';

export const contacntCandidates = 'candidate-contact';
export const unlockCandidates = 'candidate-unlock';
export const suggestedCandidateView = 'suggested-candidates-view';

export const accountSwitch = 'accounts-switch';
export const longlistAction = 'longlist-action';
export const clientView = 'client-view';
